import { AccountFeatures, AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from "react-intl"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import CreditMemoModalLink from '../../invoice/creditmemomodallink.component'
import PaymentTypeIcon from "../../invoice/paymenttypeicon.component.jsx"
import FeeModal from '../../quote/FeeModal'
import DepositQuote from "../../quote/deposit.component.jsx"
import DiscountQuote from "../../quote/discount.component.jsx"
import FeeQuote from "../../quote/fee.component.jsx"
import LoyaltyQuote from '../../quote/loyalty.component.jsx'
import TaxQuote from "../../quote/tax.component.jsx"
import { Guard, Permissions } from "../../role/Guard.jsx"
import { PAYMENT_STATUS } from "../../state/helpers/Payment"
import { DEPOSIT_TYPE } from '../../state/pricing/DepositTypes'
import { DISCOUNT_TYPE } from '../../state/pricing/DiscountType'
import { isBottomPriceEnabled } from "../../state/pricing/selectors"
import GlobalHelper from '../GlobalHelper.jsx'
import Icon from "../icon/icon.component"
import BillingMethodTotalLabel from "./billingmethodtotallabel.component.jsx"

class PricingTableTotal extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || 'col-xl-5 col-lg-6 col-md-12',
            total: this.props.total || null,
            allowEdit: this.props.allowEdit === true,
            contactId: this.props.contactId || '',
            quoteId: this.props.quoteId || '',
            stockDocument: this.props.stockDocument || {},
            invoiceId: this.props.invoiceId || '',
            mainObject: this.props.mainObject || '',
            objectId: this.props.objectId || '',
            depositAmount: this.props.depositAmount || '0',
            depositType: this.props.depositType || '',
            depositRatio: this.props.depositRatio || 0,
            onChange: this.props.onChange || function () { },
            billingMethodsCount: this.props.billingMethodsCount || 3,
            hideDeposit: this.props.hideDeposit || false,
            hideMargin: this.props.hideMargin || false,
            showLoyalty: this.props.showLoyalty || false,
            payments: this.props.payments || [],
            setFeeModal: '',
            numberOfDiscount: 0,
        }
        this.openSetDiscountModal = this.openSetDiscountModal.bind(this)
        this.closeSetDiscountModal = this.closeSetDiscountModal.bind(this)
        this.openSetTaxModal = this.openSetTaxModal.bind(this)
        this.closeSetTaxModal = this.closeSetTaxModal.bind(this)
        this.openSetFeeModal = this.openSetFeeModal.bind(this)
        this.closeSetFeeModal = this.closeSetFeeModal.bind(this)
        this.openSetDepositModal = this.openSetDepositModal.bind(this)
        this.openLoyaltyModal = this.openLoyaltyModal.bind(this)
        this.closeLoyaltyModal = this.closeLoyaltyModal.bind(this)
        this.getFeeIds = this.getFeeIds.bind(this)
        this.shouldDisplayBottomPrice = this.shouldDisplayBottomPrice.bind(this)
    }

    componentDidMount() {
        if (this.state.showLoyalty) {
            this.refreshAvailableDiscounts()
        }
    }

    getFeeIds() {
        let feeIds = []
        if (this.state.total.attributes?.feeCalculations.length > 0) {
            feeIds = this.state.total.attributes.feeCalculations.map(fee =>
            ({
                feeId: fee.attributes.fee.id,
                feeRate: fee.attributes.feeRate,
                daysAfterDueDate: fee.attributes.feeDaysAfterDueDate,
                pricingFeeCalculationId: fee.id,
            }))
        }
        return feeIds
    }

    refreshAvailableDiscounts() {
        AppContext.getApiClient().get('/contacts/' + this.state.contactId + '/loyalty-customers').then(c => {
            this.setState({
                numberOfDiscount: c.attributes.availableDiscounts.filter(d => parseFloat(d.attributes.discountValue) > 0).length,
            })
        })
    }

    componentWillReceiveProps(nextProps) {
        const contactId = this.state.contactId
        this.setState({
            className: nextProps.className || 'col-xl-5 col-lg-6 col-md-12',
            contactId: nextProps.contactId || '',
            quoteId: nextProps.quoteId || '',
            invoiceId: nextProps.invoiceId || '',
            mainObject: nextProps.mainObject || '',
            objectId: nextProps.objectId || '',
            stockDocument: this.props.stockDocument || {},
            depositType: nextProps.depositType || "",
            depositAmount: nextProps.depositAmount || '0',
            depositRatio: nextProps.depositRatio || 0,
            total: nextProps.total || null,
            allowEdit: nextProps.allowEdit === true,
            onChange: nextProps.onChange || function () { },
            billingMethodsCount: nextProps.billingMethodsCount || 3,
            hideDeposit: nextProps.hideDeposit || false,
            showLoyalty: nextProps.showLoyalty || false,
            payments: nextProps.payments || [],
        }, () => {
            if (this.state.showLoyalty && contactId !== nextProps.contactId) {
                this.refreshAvailableDiscounts()
            }
        })
    }

    openSetDiscountModal(e) {
        //define which default unit to use for the discount type selector
        let defaultSelectedDiscountUnit = "currencyAmount"
        switch (this.state.total.attributes.discountType) {
            case DISCOUNT_TYPE.DISCOUNT_PERCENT_BEFORE_TAXES:
                defaultSelectedDiscountUnit = "percentage"
                break;
        }
        const isDiscountCurrentlySet = (this.state.total.attributes.discountType != ("none" || ""))
        this.setState({
            setDiscountModal: <DiscountQuote
                selectedOptionKey={defaultSelectedDiscountUnit}
                discountName={this.state.total.attributes.discountName}
                discountValue={this.state.total.attributes.discountValue}
                isDiscountCurrentlySet={isDiscountCurrentlySet}
                billingMethod={this.state.total.attributes.billingMethod}
                currency={this.state.total.attributes.currency}
                quoteId={this.state.quoteId}
                stockDocumentId={this.state.stockDocument.id}
                invoiceId={this.state.invoiceId}
                mainObject={this.state.mainObject}
                objectId={this.state.objectId}
                onClose={this.closeSetDiscountModal}
            />
        })
        e.preventDefault()
    }

    openLoyaltyModal(e) {
        this.setState({
            setDiscountModal: <LoyaltyQuote
                contactId={this.state.contactId}
                invoiceId={this.state.invoiceId}
                onClose={this.closeLoyaltyModal} />
        })
        e.preventDefault()
    }

    closeSetDiscountModal() {
        this.setState({
            setDiscountModal: ''
        })
        this.state.onChange()
    }

    closeLoyaltyModal() {
        this.setState({
            setDiscountModal: ''
        })
        this.refreshAvailableDiscounts()
        this.state.onChange()
    }

    getFormattedRate(c) {
        switch (c.attributes.fee.attributes.rateType) {
            case "flat-rate":
                return ""
            default:
                return "(" + c.attributes.feeRate + "%)"
        }
    }

    openSetTaxModal(e) {
        this.setState({
            setTaxModal: <TaxQuote
                taxId={this.state.total.attributes.taxId}
                billingMethod={this.state.total.attributes.billingMethod}
                quoteId={this.state.quoteId}
                stockDocument={this.props.stockDocument}
                onChange={this.props.onChange}
                invoiceId={this.state.invoiceId}
                pricingTableId={this.props.pricingTableId}
                mainObject={this.state.mainObject}
                mainObjectId={this.state.objectId || this.props.pricingTableId}
                onClose={this.closeSetTaxModal} />
        })
        e.preventDefault()
    }

    closeSetTaxModal() {
        this.setState({
            setTaxModal: ''
        })
        this.state.onChange()
    }

    openSetFeeModal(e) {
        let feeId = ''
        if (this.state.total.attributes.feeCalculations.length > 0) {
            feeId = this.state.total.attributes.feeCalculations[0].attributes.fee.id
        }
        this.setState({
            setFeeModal: <FeeQuote
                feeId={feeId}
                billingMethod={this.state.total.attributes.billingMethod}
                quoteId={this.state.quoteId}
                invoiceId={this.state.invoiceId}
                mainObject={this.state.mainObject}
                objectId={this.state.objectId}
                onClose={this.closeSetFeeModal} />
        })
        e.preventDefault()
    }

    closeSetFeeModal() {
        this.setState({
            setFeeModal: ''
        })
        this.state.onChange()
    }

    openSetDepositModal(e) {
        this.setState({
            setFeeModal: <DepositQuote
                depositRatio={this.state.depositRatio}
                depositAmount={this.state.depositAmount}
                depositType={this.state.depositType}
                quoteId={this.state.quoteId}
                invoiceId={this.state.invoiceId}
                currency={this.state.total.attributes.currency}
                mainObject={this.state.mainObject}
                objectId={this.state.objectId}
                totalAmount={this.state.total.attributes.totalAmount}
                onClose={this.closeSetFeeModal} />
        })
        e.preventDefault()
    }

    displayPaymentTransactions(bgColor, textColor, balance) {
        const getDepositMessage = (pay) => {
            return parseFloat(pay.amount) >= 0 ?
                <FormattedMessage
                    id="order_deposit.edit.numbers.deposit_on"
                    defaultMessage="Deposit {referenceIdentifier} on {object}"
                    values={{
                        object: <Link to={'/' + pay.objectType + '/' + pay.objectId + '/edit'}>
                            {pay.objectIdentifier}
                        </Link>,
                        referenceIdentifier: < CreditMemoModalLink
                            creditMemoId={pay.creditMemoId}
                            creditMemoIdentifier={pay.referenceIdentifier}
                            contactId={this.state.contactId} />
                    }}
                />
                :
                <em>
                    <small>
                        <FormattedMessage
                            id="order_deposit.edit.numbers.deposit_refunded_on"
                            defaultMessage="Refund on {referenceIdentifier}"
                            values={{
                                referenceIdentifier: pay.referenceIdentifier,
                            }}
                        />
                    </small>
                </em>
        }
        return <div className="row mt-3">
            <div className={"col-12 text-align-right " + bgColor}>
                <h5 className={"pr-1 pt-3 " + textColor}>
                    <strong>
                        <FormattedMessage
                            id="quote.edit.numbers.received_payments"
                            defaultMessage="Received payments"
                        />
                    </strong>
                </h5>
            </div>
            <div className={"col-12 text-align-right " + bgColor}>
                <dl className={"row pr-1 " + textColor}>
                    {this.state.payments.filter(pay => pay.status != PAYMENT_STATUS.DECLINED && pay.status != PAYMENT_STATUS.TRANSFERRED).map(pay => {
                        return [
                            <dt className="col-6" key={1}>
                                <PaymentTypeIcon value={pay.paymentType} className={'mr-1'} />
                                {['quotes', 'orders', 'price-lists'].includes(pay.objectType) ?
                                    getDepositMessage(pay)
                                    :
                                    <FormattedMessage
                                        id="quote.edit.numbers.payment_on"
                                        defaultMessage="Payment on {object}"
                                        values={{
                                            object: <Link to={'/' + pay.objectType + '/' + pay.objectId + '/edit'}>
                                                {pay.objectIdentifier}
                                            </Link>
                                        }}
                                    />}

                            </dt>,
                            <dd className="col-6" key={2}>
                                <FormattedNumber
                                    style="currency"
                                    currency={pay.currency}
                                    value={pay.amount}
                                />
                            </dd>
                        ]
                    })}
                    <dt className="col-6" style={{
                        fontSize: '20px'
                    }}>
                        <FormattedMessage
                            id="quote.edit.numbers.balance"
                            defaultMessage="Balance"
                        />
                    </dt>
                    <dd className="col-6" style={{
                        fontSize: '20px'
                    }}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={balance}
                        />
                    </dd>

                </dl>
            </div>
        </div>
    }

    shouldDisplayBottomPrice = () => {
        const isFeatureEnabled = AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBottomLinePrice)
        return this.state.total.attributes.totalBottomPriceAmount > 0 && this.props.isBottomPriceEnabled && isFeatureEnabled
    }

    displayRoundingAdjustment = () => {
        return parseFloat(this.state.total.attributes.roundingAdjustment) > 0 &&
            <>
                <dt className="col-6">
                    <FormattedMessage
                        id="quote.edit.numbers.rounding_adjustment"
                        defaultMessage="Rounding adjustment" />
                </dt>
                <dd className="col-6">
                    <FormattedNumber
                        style="currency"
                        currency={this.state.total.attributes.currency}
                        value={this.state.total.attributes.roundingAdjustment} />
                </dd>
            </>
    }

    render() {
        if (!this.state.total) {
            return <div />
        }
        const hasDeposit = parseFloat(this.state.depositRatio) > 0 && this.state.total.attributes.billingMethod === "one-time" &&
            !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures()
        const textColor = this.state.total.attributes.totalAmount < 0 ? "" : ""
        const bgColor = this.state.total.attributes.totalAmount < 0 ? "bg-warning" : "bg-light"
        const btnClass = this.state.total.attributes.totalAmount < 0 ? 'btn-secondary' : 'btn-outline-primary'
        const balance = parseFloat(this.state.total.attributes.totalAmount) - this.state.payments.filter(pay => pay.status != PAYMENT_STATUS.DECLINED && pay.status != PAYMENT_STATUS.TRANSFERRED).map(pay => parseFloat(pay.amount)).reduce((acc, val) => acc + val, 0)
        return (
            <div className={"row pt-4 px-3 justify-content-end"}>
                <div className={this.state.className}>
                    <div className="row">
                        <div className={"col-12 text-align-right " + bgColor}>
                            <h5 className={"pr-1 pt-3 " + textColor}>
                                <strong>
                                    <BillingMethodTotalLabel
                                        value={this.state.total.attributes.billingMethod}
                                        billingMethodsCount={this.state.billingMethodsCount}
                                    />
                                </strong>
                            </h5>
                        </div>
                        <div className={"col-12 text-align-right " + bgColor}>
                            {this.state.allowEdit ? <div className="row">
                                <div className="col-12 text-right mb-3 pr-2">
                                    {this.state.total.attributes.billingMethod === 'one-time' && this.state.showLoyalty ?
                                        <a href="#" onClick={this.openLoyaltyModal} className={"btn btn-sm mx-1 "
                                            + btnClass}>
                                            <FormattedMessage
                                                id="quote.edit.loyalty_quote_btn"
                                                defaultMessage="Loyalty"
                                            />
                                            {this.state.numberOfDiscount > 0 ? <span className="ml-2 badge badge-custom-primary pt-1 pl-1">{this.state.numberOfDiscount}</span> : ''}
                                        </a> : ''}
                                    {this.state.total.attributes.billingMethod === 'one-time' && !this.state.hideDeposit &&
                                        !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                                        <a href="#" onClick={this.openSetDepositModal} className={"btn btn-sm mx-1 "
                                            + btnClass}>
                                            <FormattedMessage
                                                id="quote.edit.deposit_quote_btn"
                                                defaultMessage="Deposit"
                                            />
                                        </a>}

                                    <FeeModal
                                        feeIds={this.getFeeIds()}
                                        mainObject={this.state.mainObject}
                                        quoteId={this.state.quoteId}
                                        invoiceId={this.state.invoiceId}
                                        objectId={this.state.objectId}
                                        pricingTableId={this.props.pricingTableId}
                                        billingMethod={this.state.total.attributes.billingMethod}
                                        onApplyFee={() => this.state.onChange()}
                                    />

                                    {this.state.total.attributes.billingMethod === 'one-time' &&
                                        <a title={'Global discount'} href="#" onClick={this.openSetDiscountModal} className={"btn btn-sm mx-1 " + btnClass}>
                                            <FormattedMessage
                                                id="quote.edit.discount_quote_btn"
                                                defaultMessage="Discount"
                                            />
                                        </a>}
                                    {((this.props.stockDocument && this.props.stockDocument.status.attributes.state == "draft") || !this.props.stockDocument) &&
                                        <a href="#" onClick={this.openSetTaxModal} className={"btn btn-sm mx-1 " + btnClass}>
                                            <FormattedMessage
                                                id="quote.edit.tax_quote_btn"
                                                defaultMessage="Set tax"
                                            />
                                        </a>}
                                </div>
                            </div> : ''}
                            <dl className={"row pr-1 " + textColor}>
                                <dt className="col-6">
                                    <FormattedMessage
                                        id="quote.edit.numbers.sub_total"
                                        defaultMessage="Subtotal"
                                    />
                                </dt>
                                <dd className="col-6">
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.total.attributes.currency}
                                        value={this.state.total.attributes.subtotalAmount}
                                    />
                                </dd>

                                {
                                    [
                                        parseFloat(this.state.total.attributes.discountTotalAmount) !== 0 ? <dt className="col-6">
                                            {this.state.total.attributes.discountName ? this.state.total.attributes.discountName : <FormattedMessage
                                                id="quote.edit.numbers.discount_total"
                                                defaultMessage="Discount"
                                            />}
                                        </dt> : '',
                                        parseFloat(this.state.total.attributes.discountTotalAmount) !== 0 ? <dd className="col-6">
                                            <FormattedNumber
                                                style="currency"
                                                currency={this.state.total.attributes.currency}
                                                value={parseFloat(this.state.total.attributes.discountTotalAmount) * -1}
                                            />
                                        </dd> : '',
                                        this.state.total.attributes.feeCalculations.map(c => {
                                            return [
                                                <dt className="col-6" key={c.id + '-0'}>
                                                    {(c.attributes.feeName || c.attributes.fee.attributes.name) + this.getFormattedRate(c)
                                                    }
                                                </dt>,
                                                <dd className="col-6" key={c.id + '-1'}>
                                                    <FormattedNumber
                                                        style="currency"
                                                        currency={this.state.total.attributes.currency}
                                                        value={c.attributes.amount}
                                                    />
                                                </dd>,
                                            ]
                                        }),
                                        (parseFloat(this.state.total.attributes.discountTotalAmount) !== 0 ||
                                            this.state.total.attributes.feeCalculations.length > 0) ? <dt className="col-6">
                                            <FormattedMessage
                                                id="quote.edit.numbers.sub_total"
                                                defaultMessage="Subtotal"
                                            />
                                        </dt> : '',
                                        (parseFloat(this.state.total.attributes.discountTotalAmount) !== 0 ||
                                            this.state.total.attributes.feeCalculations.length > 0) ? <dd className="col-6">
                                            <FormattedNumber
                                                style="currency"
                                                currency={this.state.total.attributes.currency}
                                                value={this.state.total.attributes.totalAmountWithoutTax}
                                            />
                                        </dd> : '',
                                    ]
                                }

                                {
                                    this.state.total.attributes.taxCalculations.map(c => {
                                        return [
                                            <dt className="col-6" key={0}>
                                                {c.attributes.taxComponent.attributes.name} {c.attributes.taxableAmount && <small>(<FormattedNumber
                                                    style="currency"
                                                    currency={this.state.total.attributes.currency}
                                                    value={c.attributes.taxableAmount}
                                                /> @ {c.attributes.taxRate}%)</small>}
                                            </dt>,
                                            <dd className="col-6" key={1}>
                                                <FormattedNumber
                                                    style="currency"
                                                    currency={this.state.total.attributes.currency}
                                                    value={c.attributes.taxAmount}
                                                />
                                            </dd>,
                                        ]
                                    })
                                }
                                {this.displayRoundingAdjustment()}
                                <dt className="col-6" style={{
                                    fontSize: '24px'
                                }}>
                                    <FormattedMessage
                                        id="quote.edit.numbers.total"
                                        defaultMessage="Total"
                                    />
                                </dt>
                                <dd className="col-6" style={{
                                    fontSize: '24px'
                                }}>
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.total.attributes.currency}
                                        value={this.state.total.attributes.totalAmount}
                                    />
                                </dd>
                                {
                                    (this.shouldDisplayBottomPrice() &&
                                        [
                                            <dt className="col-6">
                                            </dt>,
                                            <dd className="col-6">
                                                <small>
                                                    <Icon value="arrow-circle-down" />
                                                    <FormattedNumber
                                                        style="currency"
                                                        currency={this.state.total.attributes.currency}
                                                        value={this.state.total.attributes.totalBottomPriceAmount}
                                                    />
                                                </small>
                                            </dd>
                                        ]
                                    )
                                }
                                {this.state.total.attributes.baseCurrency !== this.state.total.attributes.currency ? <dt className="col-6">
                                    <FormattedMessage
                                        id="quote.edit.numbers.base_currency_total"
                                        defaultMessage="Total in {currency}"
                                        values={{
                                            currency: this.state.total.attributes.baseCurrency
                                        }}
                                    />
                                </dt> : ''}
                                {this.state.total.attributes.baseCurrency !== this.state.total.attributes.currency ? <dd className="col-6">
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.total.attributes.baseCurrency}
                                        value={this.state.total.attributes.baseCurrencyTotalAmount}
                                    />
                                </dd> : ''}
                                {!this.state.hideMargin && Guard.isAuthorized(Permissions.ShowMargin) && <dt className="col-6">
                                    <FormattedMessage
                                        id="quote.edit.numbers.margin"
                                        defaultMessage="Margin"
                                    />
                                </dt>}
                                {!this.state.hideMargin && Guard.isAuthorized(Permissions.ShowMargin) && <dd className="col-6">
                                    (<FormattedNumber
                                        style="percent"
                                        value={this.state.total.attributes.marginRatio}
                                    />)
                                    &nbsp;
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.total.attributes.baseCurrency}
                                        value={this.state.total.attributes.margin}
                                    />
                                </dd>}
                                {hasDeposit ? <dt className="col-6">
                                    <FormattedMessage
                                        id="quote.edit.numbers.deposit"
                                        defaultMessage="Deposit"
                                    />
                                </dt> : ''}
                                {hasDeposit && <dd className="col-6">
                                    {parseFloat(this.state.depositRatio) > 0 && this.state.depositType != DEPOSIT_TYPE.FLAT_DEPOSIT && <span className={'mr-1'}>
                                        (<FormattedNumber
                                            style="percent"
                                            value={this.state.depositRatio}
                                        />)
                                    </span>}
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.total.attributes.currency}
                                        value={this.state.depositAmount}
                                    />
                                </dd>}
                            </dl>
                        </div>
                    </div>
                    {
                        this.state.total.attributes.billingMethod === 'one-time' && this.state.payments.length > 0 &&
                        this.displayPaymentTransactions(bgColor, textColor, balance)
                    }
                </div>
                {this.state.setDiscountModal}
                {this.state.setTaxModal}
                {this.state.setFeeModal}
            </div>
        )
    }
}
const mapState = (state, props) => {
    const id = props.quoteId
    return {
        ...props,
        isBottomPriceEnabled: isBottomPriceEnabled(state, id)
    }
}
export default connect(mapState, {})(PricingTableTotal)


// WEBPACK FOOTER //
// ./src/common/pricing/total.component.jsx